import styledC from 'styled-components';

import { IconButton } from '@adsk/alloy-react-button';
import { XCircleFilledIcon } from '@adsk/alloy-react-icon';
import { SearchFieldDesignTokens } from '@adsk/alloy-react-styles';

type ClearButtonProps = {
  $tokens?: SearchFieldDesignTokens;
};

export const ClearButton = styledC(IconButton).attrs({
  renderIcon: XCircleFilledIcon.renderIcon,
})<ClearButtonProps>`
  color: ${({ $tokens }) => $tokens?.clearButton?.icon?.fill};
`;
